import { controls } from "../../controls";


const hr15 = {
  label: "Employee Information",
  pageLabel: "Employee Information",
  starting: true,
  url: "hr15",
  pageType: "history",
  filter: [

    ...controls.displayText({ tab: "filter", label: "Employee Code", width: "col-sm-2" }),
    ...controls.oc({ tab: "filter", c: "Employee", placeHolder: "Employee", name: "employee_code", width: "col-sm-2" }),
    ...controls.showData({ tab: "filter", data: "employee_display", width: "col-sm-2" }),

  ],
  form: [

    ...controls.displayText({ tab: "filter", star: true, label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", defaultValue: "assigned_branch" }),
    ...controls.showData({ tab: "filter", isRequired: true, data: "branch_display", name: "branch_display", width: "col-sm-3" }),

    ...controls.checkBox({ default: true, label: "Active", name: "active", width: "col-sm-2" }),
    ...controls.displayText({ label: "", width: "col-sm-3" }),

    ...controls.displayText({ label: "PF Number", width: "col-sm-2", star: true }),
    ...controls.text({ name: "pf_number", isRequired: true }),

    ...controls.displayText({ label: "Employee Code", width: "col-sm-2", star: true }),
    ...controls.text({ name: "employee_code", isRequired: true }),

    ...controls.displayText({ label: "Display Name", width: "col-sm-2", star: true }),
    ...controls.text({ name: "employee_display", isRequired: true }),


    ...controls.displayText({ tab: "create", label: "Customer Number", width: "col-sm-2", star: true }),
    ...controls.customerNumber({
      tab: "filter", displayData: {
        description: "customer_number_display", customer_number_guid: 'customer_number_guid', pan_number: "pan", birthday: "dob", address1: "address", home_phone: "home_no", work_phone: "office_no", occupation: "occupation", gender: "gender", pin: "pin", statename: "state", aadhar: "aadhar_id", address2: "add2", cintotbal: "cintotbal", customer_type: "customer_type"
      }
    }),
    ...controls.displayText({ label: "", width: "col-sm-8" }),

    ...controls.displayText({ tab: "create", label: "Name", width: "col-sm-2" }),
    ...controls.showData({ tab: "create", width: "col-sm-4", data: "customer_number_display", name: "customer_number_display" }),
    ...controls.displayText({ tab: "create", width: "col-sm-6" }),
    ...controls.displayText({ tab: "create", label: "Address", width: "col-sm-2" }),
    ...controls.showData({
      tab: "create", width: "col-sm-6", data: "address", name: "address", parents: [
        {
          name: "customer_number_display",
          match: "exist",
          show: 'readonly'
        }
      ]
    }),
    ...controls.displayText({ tab: "create", width: "col-sm-4" }),
    ...controls.displayText({ tab: "create", width: "col-sm-2" }),
    ...controls.showData({ tab: "create", width: "col-sm-2", data: "add2", name: "add2" }),
    ...controls.showData({ tab: "create", width: "col-sm-2", data: "pin", name: "pin" }),
    ...controls.showData({ tab: "create", width: "col-sm-2", data: "state", name: "state" }),
    ...controls.displayText({ tab: "create", width: "col-sm-4" }),
    ...controls.displayText({ tab: "create", label: "Phone No:", width: "col-sm-2" }),
    ...controls.displayText({ tab: "create", label: "Home No:", width: "col-sm-2" }),
    ...controls.showData({ tab: "create", width: "col-sm-2", data: "home_no", name: "home_no" }),
    ...controls.displayText({ tab: "create", label: "Office no:", width: "col-sm-2" }),
    ...controls.showData({ tab: "create", width: "col-sm-2", data: "office_no", name: "office_no" }),
    ...controls.displayText({ tab: "create", width: "col-sm-2" }),
    ...controls.displayText({ tab: "create", label: "Date Of Birth:", width: "col-sm-2" }),
    ...controls.showData({
      tab: "create", width: "col-sm-2", data: "dob", name: "dob", displaytype: 'date', onRender: [
        // // sum last column of the current table
        { f: 'calculateAge', calcType: 'sum', inputs: { source: 'pageData.dob', field: 'dob' }, resultVar: 'getCalulateage' },
        // // and set it as some other parentState.
        { f: 'setParentState', inputs: { dest: "pageData.age", source: 'allResults', field: 'getCalulateage' }, resultVar: "age" },
      ]
    }),
    ...controls.displayText({ tab: "create", label: "Age:", width: "col-sm-2" }),
    ...controls.showData({ tab: "create", width: "col-sm-2", data: "age", name: "age" }),
    ...controls.displayText({ tab: "create", label: "Gender:", width: "col-sm-2" }),
    ...controls.showData({ tab: "create", width: "col-sm-2", data: "gender", name: "gender" }),
    ...controls.displayText({ tab: "create", label: "Occupation:", width: "col-sm-2" }),
    ...controls.showData({ tab: "create", width: "col-sm-2", data: "occupation", name: "occupation" }),
    ...controls.displayText({ tab: "create", label: "Balance:", width: "col-sm-2" }),
    ...controls.showData({ tab: "create", width: "col-sm-2", data: "cintotbal", name: "cintotbal", displaytype: "currency" }),
    ...controls.displayText({ tab: "create", label: "PAN:", width: "col-sm-2" }),
    ...controls.showData({ tab: "create", width: "col-sm-2", data: "pan" }),
    ...controls.displayText({ tab: "create", label: "Aadhar UID", width: "col-sm-2" }),
    ...controls.showData({ tab: "create", width: "col-sm-2", data: "aadhar_id", name: "aadhar_id" }),



  ],

  history: {
    perPage: 10,
    reportHeader: "Employee Information",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      {
        Header: "Sr",
        type: "autoinc",
        accessor: "srno",
        align: 'center',
        width: 30,
      },
      {
        Header: "Branch Code",
        accessor: "branch_code"
      },
      {
        Header: "Employee Code",
        accessor: "employee_code",
      },
      {
        Header: "Full Name",
        accessor: "employee_display",
      }
    ]
  }
};
export default hr15;